<template>
  <b-container> 
      <h4 style="text-align:center; font-size: 32px !important; color:#00AB63 !important;" class="mt-5">Cotización se ha guardado con éxito</h4>
      <div class="mt-3">
        <b-card-group deck>
          <b-card> 
            <b-button pill variant="primary" block class="boton_createch" @click="view()" >
              <i class="far fa-save"></i> Actualizar cotización
            </b-button>
          </b-card>  
          <b-card   header-tag="header" footer-tag="footer"> 
              <b-col v-if="this.$route.params.id">
                <b-button
                  pill
                  variant="primary"
                  block
                  class="boton_createch"
                  @click="openPDF()"
                >
                  <i class="far fa-save"></i> verPDF
                </b-button>
              </b-col>
              </b-card>
        </b-card-group>
      </div> 
  </b-container>
   
</template>

<script>
export default {
methods: {
  openPDF() { 
      window.open(
        "https://services.createchenergias.mx/pdf/?id=" +JSON.parse(JSON.stringify(this.$route.params.id))+"&token="+this.token(),
        "_blank"
      );
    },
    token() {
            return this.$store.state.token
        },
        view(iduser) { 
            this.$router.push({ name: "cotizacion_id",  params: { id: this.$route.params.id } });
        },
}
}
</script>

<style> 
</style>